import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, Transition as _Transition, withModifiers as _withModifiers, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "branding-panel" }
const _hoisted_3 = { class: "branding-content" }
const _hoisted_4 = { class: "logo-section" }
const _hoisted_5 = { class: "logo-wrapper" }
const _hoisted_6 = { class: "era-logo" }
const _hoisted_7 = { class: "era-text" }
const _hoisted_8 = { class: "welcome-title" }
const _hoisted_9 = { class: "gradient-text" }
const _hoisted_10 = { class: "welcome-subtitle" }
const _hoisted_11 = { class: "features-grid" }
const _hoisted_12 = { class: "feature-icon-wrapper" }
const _hoisted_13 = { class: "feature-content" }
const _hoisted_14 = { class: "feature-title" }
const _hoisted_15 = { class: "feature-desc" }
const _hoisted_16 = { class: "branding-footer" }
const _hoisted_17 = { class: "copyright-text" }
const _hoisted_18 = { class: "form-panel" }
const _hoisted_19 = { class: "form-content" }
const _hoisted_20 = { class: "form-wrapper" }
const _hoisted_21 = { class: "form-header" }
const _hoisted_22 = { class: "header-badge" }
const _hoisted_23 = { class: "input-group" }
const _hoisted_24 = { class: "input-label" }
const _hoisted_25 = { class: "input-wrapper" }
const _hoisted_26 = { class: "input-group" }
const _hoisted_27 = { class: "input-label-row" }
const _hoisted_28 = { class: "input-label" }
const _hoisted_29 = {
  class: "forgot-link",
  href: "/forgot-password",
  tabindex: "-1"
}
const _hoisted_30 = { class: "input-wrapper" }
const _hoisted_31 = {
  key: 0,
  class: "capslock-alert"
}
const _hoisted_32 = { class: "options-row" }
const _hoisted_33 = { class: "security-notice" }
const _hoisted_34 = { class: "notice-icon" }
const _hoisted_35 = { class: "form-footer" }
const _hoisted_36 = { class: "footer-links" }
const _hoisted_37 = {
  href: "#",
  class: "footer-link"
}
const _hoisted_38 = {
  href: "#",
  class: "footer-link"
}
const _hoisted_39 = {
  href: "#",
  class: "footer-link"
}
const _hoisted_40 = { class: "portal-register-link mt-3 text-center" }
const _hoisted_41 = {
  href: "/portal/register",
  class: "footer-link",
  style: {"font-size":"0.85rem","color":"#ff5722","font-weight":"600"}
}
const _hoisted_42 = { class: "acc-header" }
const _hoisted_43 = { class: "acc-badge" }
const _hoisted_44 = { class: "acc-body" }
const _hoisted_45 = { class: "acc-primary-icon" }
const _hoisted_46 = { class: "acc-secondary-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_Toaster = _resolveComponent("Toaster")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[39] || (_cache[39] = _createElementVNode("div", { class: "animated-bg" }, [
        _createElementVNode("div", { class: "gradient-orb orb-1" }),
        _createElementVNode("div", { class: "gradient-orb orb-2" }),
        _createElementVNode("div", { class: "gradient-orb orb-3" })
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.brandLogoText), 1),
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "era-subtitle" }, "Enterprise Resource Application", -1))
              ])
            ]),
            _createElementVNode("h1", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.brandTitle), 1)
            ]),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.brandSubtitle), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "feature-card",
                key: index
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_v_icon, {
                    color: feature.color,
                    size: "28"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(feature.icon), 1)
                    ]),
                    _: 2
                  }, 1032, ["color"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("h3", _hoisted_14, _toDisplayString(feature.title), 1),
                  _createElementVNode("p", _hoisted_15, _toDisplayString(feature.desc), 1)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"stats-row\" data-v-446525aa><div class=\"stat-item\" data-v-446525aa><div class=\"stat-value\" data-v-446525aa>99.9%</div><div class=\"stat-label\" data-v-446525aa>Uptime</div></div><div class=\"stat-divider\" data-v-446525aa></div><div class=\"stat-item\" data-v-446525aa><div class=\"stat-value\" data-v-446525aa>24/7</div><div class=\"stat-label\" data-v-446525aa>Suport</div></div><div class=\"stat-divider\" data-v-446525aa></div><div class=\"stat-item\" data-v-446525aa><div class=\"stat-value\" data-v-446525aa>ISO</div><div class=\"stat-label\" data-v-446525aa>Certificat</div></div></div>", 1)),
            _createElementVNode("p", _hoisted_17, "© 2025 Else Digital Solutions S.R.L. • v" + _toDisplayString(_ctx.appVersion), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_v_icon, {
                  size: "20",
                  color: _ctx.appColor
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("mdi-shield-lock", -1)
                  ]))]),
                  _: 1
                }, 8, ["color"]),
                _cache[12] || (_cache[12] = _createElementVNode("span", null, "Autentificare Securizată", -1))
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "form-title" }, "Conectare la Cont", -1)),
              _cache[14] || (_cache[14] = _createElementVNode("p", { class: "form-description" }, "Introduceți credențialele pentru acces complet", -1))
            ]),
            _createVNode(_component_v_form, {
              modelValue: _ctx.form,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form) = $event)),
              onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"]),
              ref: "loginForm"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, [
                    _createVNode(_component_v_icon, {
                      size: "16",
                      class: "mr-1"
                    }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode("mdi-account", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[16] || (_cache[16] = _createTextVNode(" Nume Utilizator ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.credentials.username,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.credentials.username) = $event)),
                      ref: "usernameField",
                      density: "comfortable",
                      placeholder: "Introduceți numele de utilizator",
                      "prepend-inner-icon": "mdi-account-outline",
                      variant: "outlined",
                      readonly: _ctx.loading,
                      rules: [_ctx.required],
                      onKeyup: _withKeys(_ctx.focusPassword, ["enter"]),
                      autocomplete: "username",
                      class: "premium-input",
                      "hide-details": "auto"
                    }, null, 8, ["modelValue", "readonly", "rules", "onKeyup"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("label", _hoisted_28, [
                      _createVNode(_component_v_icon, {
                        size: "16",
                        class: "mr-1"
                      }, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createTextVNode("mdi-lock", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[18] || (_cache[18] = _createTextVNode(" Parolă ", -1))
                    ]),
                    _createElementVNode("a", _hoisted_29, [
                      _createVNode(_component_v_icon, { size: "14" }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode("mdi-help-circle-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[20] || (_cache[20] = _createTextVNode(" Ați uitat parola? ", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.credentials.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.credentials.password) = $event)),
                      ref: "passwordField",
                      "append-inner-icon": _ctx.visible ? 'mdi-eye-off' : 'mdi-eye',
                      type: _ctx.visible ? 'text' : 'password',
                      density: "comfortable",
                      placeholder: "Introduceți parola",
                      "prepend-inner-icon": "mdi-lock-outline",
                      variant: "outlined",
                      "onClick:appendInner": _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = !_ctx.visible)),
                      readonly: _ctx.loading,
                      rules: [_ctx.required],
                      onKeyup: _ctx.checkCapsLock,
                      autocomplete: "current-password",
                      class: "premium-input",
                      "hide-details": "auto"
                    }, null, 8, ["modelValue", "append-inner-icon", "type", "readonly", "rules", "onKeyup"])
                  ]),
                  _createVNode(_Transition, { name: "slide-fade" }, {
                    default: _withCtx(() => [
                      (_ctx.capsLockOn)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createVNode(_component_v_icon, {
                              size: "16",
                              color: "warning"
                            }, {
                              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                _createTextVNode("mdi-alert", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[22] || (_cache[22] = _createElementVNode("span", null, "Caps Lock este activat", -1))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_v_checkbox, {
                    modelValue: _ctx.rememberMe,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.rememberMe) = $event)),
                    density: "compact",
                    "hide-details": "",
                    color: _ctx.appColor,
                    class: "remember-checkbox"
                  }, {
                    label: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                      _createElementVNode("span", { class: "checkbox-label" }, "Ține-mă minte", -1)
                    ]))]),
                    _: 1
                  }, 8, ["modelValue", "color"])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      color: "info"
                    }, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createTextVNode("mdi-information-outline", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "notice-text" }, [
                    _createElementVNode("strong", null, "Notă de securitate:"),
                    _createTextVNode(" După 3 încercări eșuate consecutive, contul va fi blocat automat timp de 3 ore. ")
                  ], -1))
                ]),
                _createVNode(_component_v_btn, {
                  block: "",
                  size: "x-large",
                  color: _ctx.appColor,
                  disabled: !_ctx.form,
                  type: "submit",
                  loading: _ctx.loading,
                  onClick: _ctx.loginStep1,
                  class: "premium-btn",
                  elevation: "0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { class: "mr-2" }, {
                      default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                        _createTextVNode("mdi-login-variant", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[28] || (_cache[28] = _createTextVNode(" Autentificare ", -1)),
                    _createVNode(_component_v_icon, { class: "ml-2" }, {
                      default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                        _createTextVNode("mdi-arrow-right", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["color", "disabled", "loading", "onClick"])
              ]),
              _: 1
            }, 8, ["modelValue", "onSubmit"]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("a", _hoisted_37, [
                  _createVNode(_component_v_icon, { size: "16" }, {
                    default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                      _createTextVNode("mdi-lifebuoy", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[30] || (_cache[30] = _createElementVNode("span", null, "Centru Ajutor", -1))
                ]),
                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "separator" }, "•", -1)),
                _createElementVNode("a", _hoisted_38, [
                  _createVNode(_component_v_icon, { size: "16" }, {
                    default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                      _createTextVNode("mdi-shield-check", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[32] || (_cache[32] = _createElementVNode("span", null, "Securitate", -1))
                ]),
                _cache[36] || (_cache[36] = _createElementVNode("span", { class: "separator" }, "•", -1)),
                _createElementVNode("a", _hoisted_39, [
                  _createVNode(_component_v_icon, { size: "16" }, {
                    default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                      _createTextVNode("mdi-file-document-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[34] || (_cache[34] = _createElementVNode("span", null, "Termeni", -1))
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("a", _hoisted_41, [
                  _createVNode(_component_v_icon, { size: "16" }, {
                    default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                      _createTextVNode("mdi-account-plus", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[38] || (_cache[38] = _createElementVNode("span", null, "Înregistrare Portal HR", -1))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showCompanyDialog,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showCompanyDialog) = $event)),
      persistent: "",
      "max-width": "480"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "modern-dialog",
          elevation: "8"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "dialog-title-bar" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: _ctx.appColor,
                  size: "24",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                    _createTextVNode("mdi-domain", -1)
                  ]))]),
                  _: 1
                }, 8, ["color"]),
                _cache[41] || (_cache[41] = _createElementVNode("span", null, "Selectați Compania", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, { class: "pa-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, { class: "company-selection-list" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (c) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: c.ID,
                        onClick: ($event: any) => (_ctx.selectAndContinue(c)),
                        active: _ctx.selectedCompanyId === c.ID,
                        color: _ctx.appColor,
                        class: "company-option"
                      }, {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_avatar, {
                            color: _ctx.appColor,
                            size: "36",
                            class: "mr-3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                color: "white",
                                size: "20"
                              }, {
                                default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                                  _createTextVNode("mdi-domain", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["color"])
                        ]),
                        append: _withCtx(() => [
                          (_ctx.selectedCompanyId === c.ID)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                color: _ctx.appColor,
                                size: "20"
                              }, {
                                default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                                  _createTextVNode(" mdi-check-circle ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["color"]))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, { class: "company-option-name" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(c.Name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "active", "color"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _ctx.cancelCompany,
                  disabled: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { class: "mr-1" }, {
                      default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                        _createTextVNode("mdi-arrow-left", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[45] || (_cache[45] = _createTextVNode(" Înapoi ", -1))
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: _ctx.appColor,
                  variant: "elevated",
                  loading: _ctx.loading,
                  disabled: !_ctx.selectedCompanyId,
                  onClick: _ctx.loginStep2
                }, {
                  default: _withCtx(() => [
                    _cache[47] || (_cache[47] = _createTextVNode(" Continuă ", -1)),
                    _createVNode(_component_v_icon, { class: "ml-1" }, {
                      default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                        _createTextVNode("mdi-arrow-right", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["color", "loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showSuperAdminDialog,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showSuperAdminDialog) = $event)),
      persistent: "",
      "max-width": "450",
      transition: "dialog-bottom-transition"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "acc-card",
          elevation: "24"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_42, [
              _cache[49] || (_cache[49] = _createElementVNode("div", { class: "acc-header-glow" }, null, -1)),
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_v_icon, {
                  color: "white",
                  size: "30"
                }, {
                  default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                    _createTextVNode("mdi-shield-crown", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[50] || (_cache[50] = _createElementVNode("div", { class: "acc-header-text" }, [
                _createElementVNode("span", { class: "acc-header-title" }, "Mod de Acces"),
                _createElementVNode("span", { class: "acc-header-sub" }, "Alegeți cum doriți să continuați")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("button", {
                class: "acc-primary",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goNormal && _ctx.goNormal(...args)))
              }, [
                _cache[53] || (_cache[53] = _createElementVNode("span", { class: "acc-reco" }, "Recomandat", -1)),
                _createElementVNode("span", _hoisted_45, [
                  _createVNode(_component_v_icon, {
                    color: "white",
                    size: "30"
                  }, {
                    default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                      _createTextVNode("mdi-briefcase", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[54] || (_cache[54] = _createElementVNode("span", { class: "acc-primary-text" }, [
                  _createElementVNode("span", { class: "acc-primary-title" }, "Flux Clasic"),
                  _createElementVNode("span", { class: "acc-primary-sub" }, "Utilizare standard a platformei")
                ], -1)),
                _createVNode(_component_v_icon, {
                  color: "white",
                  size: "24",
                  class: "acc-primary-arrow"
                }, {
                  default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                    _createTextVNode("mdi-arrow-right", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[58] || (_cache[58] = _createElementVNode("div", { class: "acc-divider" }, [
                _createElementVNode("span", null, "sau")
              ], -1)),
              _createElementVNode("button", {
                class: "acc-secondary",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goSuperAdmin && _ctx.goSuperAdmin(...args)))
              }, [
                _createElementVNode("span", _hoisted_46, [
                  _createVNode(_component_v_icon, { size: "20" }, {
                    default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                      _createTextVNode("mdi-cog-outline", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _cache[57] || (_cache[57] = _createElementVNode("span", { class: "acc-secondary-text" }, [
                  _createElementVNode("span", { class: "acc-secondary-title" }, "Administrare sistem"),
                  _createElementVNode("span", { class: "acc-secondary-sub" }, "Configurare și gestionare sistem")
                ], -1)),
                _createVNode(_component_v_icon, {
                  size: "18",
                  class: "acc-secondary-arrow"
                }, {
                  default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                    _createTextVNode("mdi-chevron-right", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_Toaster, {
      snackbar: _ctx.snackbar,
      onCloseSnackbar: _ctx.SnackbarClose
    }, null, 8, ["snackbar", "onCloseSnackbar"])
  ], 64))
}